<template>
  <div class="login-container">
    <div class="login-background">
      <div class="bg-overlay"></div>
      <div class="bg-pattern"></div>
    </div>
    <div class="center">
      <div class="login-header">
        <div class="ykw">
          <i class="el-icon-car"></i>
          <span>车辆租赁管理系统</span>
        </div>
        <div class="ykw-subtitle">欢迎登录</div>
      </div>
      <div class="login-form">
        <el-form ref="form" :model="formData" label-width="0" :rules="rules">
          <el-form-item prop="account">
            <div class="input-wrapper">
              <i class="el-icon-user input-icon"></i>
              <el-input 
                v-model="formData.mobile" 
                placeholder="请输入账号"
                class="login-input"
                clearable
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item>
            <div class="input-wrapper">
              <i class="el-icon-message input-icon"></i>
              <el-input 
                class="yan-input login-input" 
                v-model="formData.code" 
                placeholder="请输入验证码"
                clearable
              >
                <template slot="append">
                  <el-link 
                    :disabled="isDisabled" 
                    :underline="false" 
                    @click="getCode" 
                    class="yan_code"
                  >
                    {{ codeStr }}
                  </el-link>
                </template>
              </el-input>
            </div>
          </el-form-item>
          <el-form-item>
            <div class="login-btn">
              <el-button
                type="primary"
                :disabled="loginDisabled"
                @click="onSubmit"
                class="submit-btn"
              >
                <i class="el-icon-right"></i>
                <span>登录</span>
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { getLoginCodeAPI } from './api';

export default {
  name: 'Login',

  data() {
    return {
      isDisabled: false,
      imgCode: '',
      formData: {
        code: '',
        mobile: '',
      },
      rules: {},
      codeStr: '获取验证码',
      codeSent: false,
    }
  },

  computed: {
    // 已发送过验证码且验证码输入不为空时，登录按钮才可点击
    loginDisabled() {
      return !this.codeSent || !this.formData.code;
    },
  },

  mounted() {},

  methods: {
    onSubmit() {
      this.$store.dispatch('Login', this.formData).then(() => {
        this.$router.push({ path: '/home' })
        sessionStorage.removeItem('keyPath')
      })
    },
     async getCode() {
      if(!this.formData.mobile) return this.$message.error('手机号必填')
      await getLoginCodeAPI(this.formData.mobile)
      this.codeSent = true
      this.isDisabled = true
      let sec = 59
      this.codeStr = `重发（${sec}s）`
      this.timer = setInterval(() => {
        sec = sec - 1
        this.codeStr = `重发（${sec}s）`
        if (sec <= 0) {
          this.codeStr = '获取验证码'
          this.isDisabled = false
          clearInterval(this.timer)
        }
      }, 1000)
    },
  }
}
</script>

<style lang="scss" scoped>
.login-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  flex: 1;
  position: relative;
  overflow: hidden;

  .login-background {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('/bg.jpg') no-repeat;
    background-size: cover;
    background-position: center;
    z-index: 0;

    .bg-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(135deg, rgba(64, 158, 255, 0.85) 0%, rgba(102, 177, 255, 0.75) 50%, rgba(64, 158, 255, 0.85) 100%);
      z-index: 1;
    }

    .bg-pattern {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-image: 
        radial-gradient(circle at 20% 50%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
        radial-gradient(circle at 80% 80%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
        radial-gradient(circle at 40% 20%, rgba(255, 255, 255, 0.05) 0%, transparent 50%);
      z-index: 2;
    }
  }

  .center {
    width: 480px;
    max-width: 90%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(20px);
    padding: 50px 40px;
    border-radius: 20px;
    box-shadow: 
      0 20px 60px rgba(0, 0, 0, 0.3),
      0 0 0 1px rgba(255, 255, 255, 0.5);
    position: relative;
    z-index: 10;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 
        0 25px 70px rgba(0, 0, 0, 0.35),
        0 0 0 1px rgba(255, 255, 255, 0.6);
      transform: translateY(-2px);
    }

    .logo-img {
      display: flex;
      align-items: center;
      margin-bottom: 32px;
      .left-logo {
        margin-right: 12px;
        width: 256px;
        height: 102px;
        img {
          width: 256px;
          margin-left: -40px;
        }
      }
      .right-txt {
        width: 78px;
        height: 24px;
        img {
          width: 78px;
          height: 24px;
        }
      }
    }
    .login-header {
      text-align: center;
      margin-bottom: 40px;

      .ykw {
        color: #1a1e25;
        line-height: 1.2;
        margin-bottom: 12px;
        font-size: 28px;
        font-weight: 700;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        letter-spacing: 1px;

        i {
          font-size: 32px;
          background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        span {
          background: linear-gradient(135deg, #1a1e25 0%, #409EFF 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
      }

      .ykw-subtitle {
        color: #606266;
        font-size: 16px;
        font-weight: 400;
        letter-spacing: 0.5px;
      }
    }
    .ykw-en {
      line-height: 32px;
      font-weight: 500;
      font-size: 16px;
      color: #788692;
      margin-top: 20px;
      margin-bottom: 20px;
    }
    .login-form {
      .input-wrapper {
        position: relative;
        width: 100%;

        .input-icon {
          position: absolute;
          left: 16px;
          top: 50%;
          transform: translateY(-50%);
          font-size: 18px;
          color: #909399;
          z-index: 10;
          transition: all 0.3s ease;
        }

        .login-input {
          ::v-deep .el-input__inner {
            height: 50px;
            border-radius: 10px;
            border: 1.5px solid #e4e7ed;
            padding-left: 48px;
            font-size: 15px;
            transition: all 0.3s ease;
            background: #fafbfc;

            &:focus {
              border-color: #409EFF;
              background: #fff;
              box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.1);
            }

            &:hover {
              border-color: #c0c4cc;
            }

            &::placeholder {
              color: #c0c4cc;
            }
          }

          &:focus-within {
            .input-icon {
              color: #409EFF;
            }
          }
        }

        .yan-input {
          border-radius: 10px;
          transition: all 0.3s ease;

          &.is-focus,
          &:focus-within {
            box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.1);

            ::v-deep .el-input__inner {
              border-color: #409EFF;
              box-shadow: none !important;
              z-index: 1;
            }

            ::v-deep .el-input-group__append {
              border-color: #409EFF;
              background-color: #fff;
            }
          }

          ::v-deep .el-input__inner {
            border-right: none;
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
            border-top-left-radius: 10px;
            border-bottom-left-radius: 10px;
          }

          ::v-deep .el-input-group__append {
            background-color: #fafbfc;
            border-top-right-radius: 10px;
            border-bottom-right-radius: 10px;
            border: 1.5px solid #e4e7ed;
            border-left: none;
            padding: 0 16px;
            transition: all 0.3s ease;

            &:hover {
              background-color: #f0f2f5;
            }
          }

          .yan_code {
            font-size: 14px;
            font-weight: 500;
            color: #409EFF;
            transition: all 0.3s ease;
            padding: 0;
            white-space: nowrap;

            &:hover:not(.is-disabled) {
              color: #66b1ff;
            }

            &.is-disabled {
              color: #c0c4cc;
              cursor: not-allowed;
            }
          }
        }
      }

      .el-form-item {
        margin-bottom: 24px;

        &:last-child {
          margin-bottom: 0;
        }
      }

      .login-btn {
        display: flex;
        margin-top: 32px;

        .submit-btn {
          flex: 1;
          height: 50px;
          font-weight: 600;
          font-size: 16px;
          border-radius: 10px;
          background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
          border: none;
          box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;

          &.is-disabled,
          &.is-disabled:hover,
          &.is-disabled:focus,
          &.is-disabled:active {
            background: #e4e7ed;
            border-color: #e4e7ed;
            color: #a8abb2;
            box-shadow: none;
            opacity: 1;
            cursor: not-allowed;
            transform: none;
          }

          &:hover {
            opacity: 0.9;
            transform: translateY(-2px);
            box-shadow: 0 6px 16px rgba(64, 158, 255, 0.4);
          }

          &:active {
            transform: translateY(0);
          }

          i {
            font-size: 18px;
          }
        }
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .login-container {
    padding: 20px;

    .center {
      width: 100%;
      max-width: 100%;
      padding: 40px 30px;
      border-radius: 16px;

      .login-header {
        .ykw {
          font-size: 24px;
          flex-direction: column;
          gap: 8px;

          i {
            font-size: 28px;
          }
        }

        .ykw-subtitle {
          font-size: 14px;
        }
      }

      .login-form {
        .input-wrapper {
          .input-icon {
            left: 12px;
            font-size: 16px;
          }

          .login-input {
            ::v-deep .el-input__inner {
              height: 46px;
              padding-left: 42px;
              font-size: 14px;
            }
          }
        }

        .login-btn {
          .submit-btn {
            height: 46px;
            font-size: 15px;
          }
        }
      }
    }
  }
}

@media (max-width: 480px) {
  .login-container {
    .center {
      padding: 30px 20px;

      .login-header {
        margin-bottom: 30px;

        .ykw {
          font-size: 20px;
        }
      }
    }
  }
}
</style>
